module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v(_vm._s(_vm.$t('findTheInvisibleCow')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('instruction.intro')))]), _vm._v(" "), _c('div', {
    staticClass: "audio-warning"
  }, [_c('div', {
    staticClass: "audio-warning__icon",
    domProps: {
      "innerHTML": _vm._s(_vm.image.speaker)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "auto-warning__text"
  }, [_vm._v(_vm._s(_vm.$t('instruction.audio')))])]), _vm._v(" "), (!_vm.audioPlayer.loaded) ? _c('div', {
    staticClass: "loading-bar"
  }, [_c('div', {
    staticClass: "loading-bar-inner",
    style: (("width:" + (_vm.audioPlayer.loadedAmount * 100) + "%;"))
  })]) : _vm._e(), _vm._v(" "), (_vm.audioPlayer.loaded) ? _c('div', {
    staticClass: "start-button"
  }, [_c('find-button', {
    on: {
      "click": function($event) {
        _vm.setPage(_vm.PAGE_GAME)
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('cta.start')) + "\n    ")])], 1) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('support.possiblyUnsupported')) + "\n    "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('support.browsers'))
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-546b77d6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Welcome.vue
// module id = 179
// module chunks = 2